var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1462_9285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 9.1875H8.53125V14.1348H7.62259V12.4531C7.62154 11.5003 7.24258 10.5869 6.56887 9.91315C5.89516 9.23942 4.98171 8.86045 4.02892 8.85938H1.96875V6.23438H0.65625V20.3438H1.96875V18.3855L19.0312 18.522V20.3438H20.3438V12.4688C20.3428 11.5988 19.9967 10.7648 19.3816 10.1496C18.7665 9.53451 17.9324 9.18849 17.0625 9.1875ZM1.96875 10.1719H4.02892C4.63372 10.1726 5.21354 10.4131 5.6412 10.8408C6.06885 11.2684 6.30941 11.8482 6.31009 12.453V14.1347H1.96875V10.1719ZM19.0312 17.2095L1.96875 17.073V15.4473H19.0312V17.2095ZM19.0312 14.1348H9.84375V10.5H17.0625C17.5845 10.5006 18.0849 10.7082 18.454 11.0773C18.823 11.4464 19.0307 11.9468 19.0312 12.4688V14.1348Z",
    fill: "#3C5366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.75H8.125V13.4617H7.25961V11.8601C7.25861 10.9527 6.8977 10.0827 6.25607 9.4411C5.61444 8.79945 4.74448 8.43852 3.83707 8.4375H1.875V5.9375H0.625V19.375H1.875V17.51L18.125 17.64V19.375H19.375V11.875C19.3741 11.0465 19.0445 10.2522 18.4587 9.66633C17.8728 9.08048 17.0785 8.75094 16.25 8.75V8.75ZM1.875 9.6875H3.83707C4.41306 9.68815 4.96528 9.91725 5.37257 10.3245C5.77986 10.7318 6.00896 11.284 6.00961 11.86V13.4616H1.875V9.6875ZM18.125 16.39L1.875 16.26V14.7117H18.125V16.39ZM18.125 13.4617H9.375V10H16.25C16.7471 10.0006 17.2237 10.1983 17.5752 10.5498C17.9267 10.9013 18.1244 11.3779 18.125 11.875V13.4617Z",
    fill: "#3C5366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1462_9285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.0cb95efc0f48c2c16f9d60cc068a6934.svg";
export { ForwardRef as ReactComponent };